module.exports = __webpack_public_path__ + "img/office-1.4cb14207.png";